export default __webpack_public_path__ + "static/media/team1.358b3193.jpg";